<script setup lang="ts">
  import { Text } from "@ui-kit";
  import { Image } from "@src/components";

  const props = defineProps<{
    img?: string;
    article?: string;
    hasCis?: boolean;
    hasEpc?: boolean;
    dateSales?: string;
    isSold?: boolean;
  }>();

  const formatDate = (dateString?: string): string => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return dateString;

    const formatter = new Intl.DateTimeFormat("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    return formatter.format(date);
  };
</script>

<template>
  <div class="sales-item">
    <div class="image-container">
      <Image :url="props.img" class="image" />
    </div>
    <div class="container">
      <Text font="body-medium-16" data-testid="sales-item-article">{{ props.article }}</Text>
      <div class="row">
        <div class="cis" :class="{ 'exist': props.hasCis }" data-testid="sales-item-cis">
          <Text :color="props.hasCis ? 'success' : 'secondary'">{{ $t("КИЗ") }}</Text>
        </div>
        <div class="epc" :class="{ 'exist': props.hasEpc }" data-testid="sales-item-epc">
          <Text :color="props.hasEpc ? 'success' : 'secondary'">{{ $t("EPC") }}</Text>
        </div>
      </div>
      <div class="row status" data-testid="sales-item-status">
        <Text v-if="props.isSold" color="success" font="heading-H5">{{ formatDate(props.dateSales) }}</Text>
        <Text v-else color="error" font="heading-H5">{{ $t("Не продано") }}</Text>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .sales-item {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    background-color: var(--sf-base-background-white);

    .image-container {
      position: relative;
    }

    .image {
      height: 118px;
      width: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .container {
      display: flex;
      flex-direction: column;
      gap: 6px;
      flex: 1;
    }

    .row {
      display: flex;
      border-radius: 12px;
      overflow: hidden;
    }

    .status {
      padding: 12px;
      justify-content: center;
      align-items: center;
      background-color: var(--sf-base-background-secondary);
    }

    .epc,
    .cis {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      padding: 8px;
      background-color: var(--sf-base-background-secondary);
    }

    .exist {
      background-color: var(--sf-base-background-success);
    }
  }
</style>
